import { ArrowRight, Broadcast } from "@phosphor-icons/react";
import { useLang } from "../context/LanguageContext";

const HERO_BG = "/bg-home-hero.png";

export const Hero = () => {
  const { t } = useLang();

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden bg-gradient-to-b from-[#d6e6f2] via-[#b8d6ef] to-[#a8c8e2]"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_BG}
          alt=""
          aria-hidden
          className="h-full w-full object-cover object-right"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#d6e6f2] via-[#d6e6f2]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#a8c8e2]/60 via-transparent to-transparent" />
      </div>
      <div className="absolute inset-0 -z-10 grid-lines opacity-50" />
      <div className="pointer-events-none absolute -top-40 -left-40 -z-10 h-[500px] w-[500px] rounded-full bg-blue-400/20 blur-3xl" />
      <div className="pointer-events-none absolute top-0 right-0 -z-10 h-[400px] w-[400px] rounded-full bg-purple-400/15 blur-3xl" />

      <div className="mx-auto max-w-[1400px] px-6 pb-24 pt-12 md:px-12 md:pt-16 lg:px-16 lg:pb-32 lg:pt-20">
        <div className="max-w-4xl">
          <div
            data-testid="hero-overline"
            className="inline-flex items-center gap-2.5 rounded-full border border-slate-200 bg-white/80 px-5 py-2.5 shadow-sm backdrop-blur-md md:gap-3 md:px-6 md:py-3"
          >
            <span className="pulse-dot" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-700 md:text-sm">
              {(t.hero.overline || "").replace(/\s*🇦🇴\s*$/, "")}
            </span>
            <span
              className="text-xl leading-none md:text-2xl"
              aria-label="Angola"
            >
              🇦🇴
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-heading mt-10 whitespace-normal text-3xl font-black leading-tight tracking-tight text-slate-900 sm:text-4xl md:whitespace-nowrap md:text-[44px] lg:text-[56px]"
          >
            {t.hero.title_line1} {t.hero.title_line2}{" "}
            <span className="bg-gradient-to-r from-blue-600 via-blue-500 to-purple-600 bg-clip-text text-transparent">
              {t.hero.title_line3}
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg"
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
            <a
              href="#contact"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-600/25 transition-all hover:bg-blue-500 hover:shadow-blue-600/40 active:scale-95"
            >
              {t.hero.primary_cta}
              <ArrowRight
                size={16}
                weight="bold"
                className="transition-transform group-hover:translate-x-1"
              />
            </a>
            <a
              href="#services"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3.5 text-sm font-semibold text-slate-700 shadow-sm transition-all hover:border-slate-400 hover:bg-slate-50"
            >
              {t.hero.secondary_cta}
            </a>
          </div>

          <div className="mt-16 flex items-center gap-3 text-xs text-slate-500">
            <Broadcast size={16} className="text-blue-600" />
            <span className="font-mono uppercase tracking-[0.25em]">
              {t.hero.live_status}
            </span>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-10 right-[-3%] hidden select-none lg:block"
      >
        <span className="mega-type text-[180px]">TVCABSAT</span>
      </div>
    </section>
  );
};
